module.exports = __webpack_public_path__ + "static/media/MX.434d6364.svg";